/* eslint-disable max-len */
import links from './social.links.urls';

import type { ISocialLinksResponse } from './types';

export default function (
  defaultLocale: string,
  routes: { title: any; enabled?: boolean, useItl?: boolean, alias: 'fb' | 'tw' | 'ig' | 'liin', image: string, alt: string }[],
): ISocialLinksResponse[] {
  return routes
    .filter((route) => route.alias in links && (defaultLocale in links[route.alias] || route.useItl) && (route.enabled || route.enabled !== false))
    .map((route) => ({
      ...route,
      url: defaultLocale in links[route.alias] ? (links as any)[route.alias][defaultLocale] : links[route.alias].intl,
      image: `/social-logos/${route.image}`,
    }));
}
